import { Row, Col, Card, Button, Input, Form, Select, Radio, Space, InputNumber } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import { useNavigate } from "react-router";
import { Link, useParams } from "react-router-dom";
import { UploadOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import apiPath from "../../../constants/apiPath";

function Add() {

    const sectionName = "Attribute";
    const routeName = "product/attribute";

    const api = {
        addEdit: apiPath.attribute,
        category: apiPath.categoryList
    }

    const [form] = Form.useForm();
    const { request } = useRequest()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const [categoryList, setCategoryList] = useState([])
    const [attributeType, setAttributeType] = useState()
    const { id } = useParams()

    const handleAttributeType = (data) => {
        setAttributeType(data);
    }

    const getCategoryList = () => {
        request({
            url: api.category + "/" + 'product',
            method: 'GET',
            onSuccess: (data) => {
                setCategoryList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    };


    const onCreate = (formvalues) => {


        const { name, options, category_id, is_mandatory, is_image_require, type } = formvalues
        const payload = { name, category_id, is_mandatory, is_image_require, options, type };

        // payload.type = attributeType ? attributeType : 'text';

        setLoading(true)
        request({
            url: !id ? api.addEdit : `${api.addEdit}/${id}`,
            method: !id ? 'POST' : 'PUT',
            data: payload,
            onSuccess: (data) => {
                setLoading(false)
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS)
                    navigate(`/pimptup-admin/${routeName}`);
                } else {
                    ShowToast(data.message, Severty.ERROR)
                }
            },
            onError: (error) => {
                ShowToast(error.response.data.message, Severty.ERROR)
                setLoading(false)
            },
        })
    };

    const fetchData = (id) => {
        request({
            url: api.addEdit + "/" + id,
            method: 'GET',
            onSuccess: ({ data }) => {
                setLoading(false);
                form.setFieldsValue({
                    ...data,
                    category_id: data?.category_id?._id,
                    options: data.options.map(({ value }) => value)
                })
            },
            onError: (error) => {
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    useEffect(() => {
        if (!id) return
        fetchData(id);
    }, [id])

    useEffect(() => {
        getCategoryList();
    }, [])

    return (
        <>
            <Card title={"Add " + sectionName}>
                <Form
                    initialValues={{
                        is_image_require: false,
                        is_mandatory: true,
                        options: [null]
                    }}
                    className="edit-page-wrap addAttribute"
                    form={form}
                    onFinish={onCreate}
                    autoComplete="off"
                    layout="verticle"
                    name="catalogue_form">
                    <Row gutter={[12, 0]}>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="category-elt"
                                name="category_id"
                                label="Select Category"
                                rules={[{ required: true, message: 'Missing Category Selection' }]}
                            >
                                <Select placeholder="Select Category">
                                    {categoryList.map((item, index) => (
                                        <option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item
                                normalize={value => value.trimStart()}
                                label="Name"
                                name="name"
                                rules={[
                                    { required: true, message: "Please Enter the name!" },
                                    { max: 200, message: "Name must contain maximum 200 characters " },
                                    { min: 2, message: "Name must contain minimum 2 " },
                                ]}
                            >
                                <Input autoComplete="off" placeholder="Enter Attribute Name" />
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item label="Attribute is" name="is_mandatory">
                                <Radio.Group>
                                    <Radio value={true}>Mandatory</Radio>
                                    <Radio value={false}>Optional</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item label="Image Require for Product" name="is_image_require">
                                <Radio.Group>
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>NO</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        <Col span={24} md={16} lg={24} xl={16} xxl={12}>
                            <Form.Item label="Type" name="type"
                                rules={[
                                    { required: true, message: "Please Select type!" },
                                ]}>
                                <Select placeholder="Select Attribute Type" >
                                    <option key={"general"} value={"general"}>General</option>
                                    <option key={"color"} value={"color"}>Color</option>
                                    <option key={"size"} value={"size"}>Size</option>
                                    <option key={"quantity"} value={"quantity"}>Quantity</option>
                                </Select>
                            </Form.Item>
                        </Col>

                        {/* <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item
                                label="Base Price (R)"
                                name="price"
                                rules={[
                                    { required: true, message: "Please Enter the Price!" },
                                ]}
                            >
                                <InputNumber type="number" autoComplete="off" placeholder="Enter Attribute Price" />
                            </Form.Item>
                        </Col> */}
                    </Row>

                    <Row gutter={[12, 0]}>

                        <Col span={24}>

                            <Form.List name="options" className="mt-2">
                                {(fields, { add, remove }, { form }) => (
                                    <>
                                        <Row gutter={[12, 0]}>
                                            {fields.map((field, index) => (
                                                <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                                                    <div key={field.key}>
                                                        <Space key={field.key} align="baseline" className="gap-cls">
                                                            <div className="" style={{ display: "flex", gap: "8px" }}>
                                                                <Form.Item className="qty-cls w-100 customRowDesign"
                                                                    {...field}
                                                                    name={[field.name]}
                                                                    label={"Attribute Values (" + (index + 1) + ")"}
                                                                    rules={[{ required: true, message: 'Please enter attribute option value' }]}
                                                                    normalize={value => value.trimStart()}
                                                                >
                                                                    <Input autoComplete="off" placeholder="Enter Attribute Value" />

                                                                </Form.Item>

                                                                {index > 0 ?
                                                                    <div className="minus-wrap" style={{ marginTop: "22px" }}>
                                                                        <MinusCircleOutlined onClick={() => remove(field.name)} style={{ borderRadius: "8px", margin: '0' }} />
                                                                    </div>
                                                                    : null}
                                                            </div>
                                                        </Space>
                                                    </div>
                                                </Col>
                                            ))}
                                            <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                                                <Form.Item label="Add Values" className="mt-2">
                                                    <Button onClick={() => add()} block icon={<PlusOutlined />}></Button>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </Form.List>
                        </Col>

                    </Row>


                    <Form.Item className="btn-row float-right">
                        <Link className="ant-btn ant-btn-primary" to={`/pimptup-admin/${routeName}`}>Back</Link>
                        <Button type="primary" loading={loading} htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            </Card>
        </>
    )
}


export default Add;
